import React, { useState } from 'react';
import { hotjar } from 'react-hotjar';
import {
    Grid,
} from '@mui/material';

import {
    ChildTabs
} from '../Common';

import InventoryMechanical from './InventoryMechanical';
import InventoryCylinder from './InventoryCylinder';
import InventoryGeneral from './InventoryGeneral';
import InventoryMeter from './InventoryMeter';

export const Inventory = ({
    id,
    currentTab,
    handleTabChange
}) => {
    const [activeTab, setActiveTab] = useState(currentTab);
    const tabLabels = [
        "Mechanical Equipment",
        "Cylinders",
        "General Inventory",
        "Meters"
    ];

    return (
        <ChildTabs
            activeTab={activeTab}
            onhandleChange={(event, newValue) => {
                handleTabChange(newValue);
                setActiveTab(newValue);
                hotjar.stateChange(document.URL + '#' + tabLabels[newValue - 1]);
            }}
            labels={tabLabels}
            tabElements={[
                <Grid
                    container
                    style={{ marginBottom: '2%' }}
                >
                    <Grid item xs={12} lg={12} mb={1} pt={2}>
                        <InventoryMechanical id={id} />
                    </Grid>
                </Grid>,
                <Grid
                    container
                    style={{ marginBottom: '2%' }}
                >
                    <Grid item xs={12} lg={12} mb={1} pt={2}>
                        <InventoryCylinder id={id} />
                    </Grid>
                </Grid>,
                <Grid
                    container
                    style={{ marginBottom: '2%' }}
                >
                    <Grid item xs={12} lg={12} mb={1} pt={2}>
                        <InventoryGeneral id={id} />
                    </Grid>
                </Grid>,
                <Grid
                    container
                    style={{ marginBottom: '2%' }}
                >
                    <Grid item xs={12} lg={12} mb={1} pt={2}>
                        <InventoryMeter id={id} />
                    </Grid>
                </Grid>
            ]}
            tabCustomStyle={{ ml: "25px" }}
            tabPanelCustomStyle={{ ml: "8px" }}
        />
    );
};